/**
 * region for libraries*/
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';

/**
 * region for styles*/
import { selectContentStyle } from './style/selectContentStyle';

/**
 * region for redux*/
import { connect } from 'react-redux';
import { MiniSitesActions } from '../../actions/MiniSitesActions';

/**
 * region for componets*/
import SelectContentSearch from './common/SelectContentSearch';
import SelectContentSearchTable from './common/SelectContentSearchTable';


class SelectContent extends Component {

    state = {
        reload: false,
        pageNumberEventList: 1,
        pageSizeEventList: 10,
        newMiniSiteEventSearchField: ""
    };

    componentDidMount() {
        const reload = this.props.reload;
        this.setState({ reload: reload });
    }

    fetchMiniSiteSetAttributes(newMiniSiteEventSearchField) {
        const { pageNumberEventList, pageSizeEventList } = this.state;
        let dataRequest = {
            description: newMiniSiteEventSearchField,
            pageNumberEventList: pageNumberEventList,
            pageSizeEventList: pageSizeEventList
        };
        this.setState({ newMiniSiteEventSearchField: newMiniSiteEventSearchField });
        this.fetchMiniSiteGetListEvents(dataRequest);
    }

    onChangePage(newPage) {
        const { pageSizeEventList, newMiniSiteEventSearchField } = this.state;
        newPage = newPage + 1;
        let dataRequest = {
            description: newMiniSiteEventSearchField,
            pageNumberEventList: newPage,
            pageSizeEventList: pageSizeEventList
        };
        this.setState({ pageNumberEventList: newPage, pageSizeEventList: pageSizeEventList, newMiniSiteEventSearchField: newMiniSiteEventSearchField });
        this.props.fetchMiniSiteGetListEvents(dataRequest);
    }

    onChangeSelectList(dataSelectContent) {
        this.props.fetchMiniSiteSetAttributesSelectListEvents(dataSelectContent);
    }

    fetchMiniSiteGetListEvents(dataRequest) {
        this.props.fetchMiniSiteGetListEvents(dataRequest);
    }

    render() {
        const { classes } = this.props;
        const { searchResultListEvents, dataSelectContent, backoffficeUrl } = this.props;
        const { pageNumberEventList, pageSizeEventList } = this.state;
        return (
            <Fragment>
                <Grid container direction="row" justify="flex-start" alignItems="flex-start" spacing={1}>
                    <Grid container spacing={1}>
                        <Grid item sm={12}>
                            <SelectContentSearch
                                onAttributeUpdate={this.fetchMiniSiteSetAttributes.bind(this)} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={1} className={classes.marginSearch}>
                        <Grid item sm={12}>
                            <SelectContentSearchTable
                                onChangePage={this.onChangePage.bind(this)}
                                onChangeSelectList={this.onChangeSelectList.bind(this)}
                                searchResultListEvents={searchResultListEvents}
                                dataSelectContent={dataSelectContent}
                                backoffficeUrl={backoffficeUrl}
                                pageSizeEventList={pageSizeEventList}
                                pageNumberEventList={pageNumberEventList}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Fragment>
        );
    }
}
SelectContent.propTypes = {
    classes: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    const searchResultListEvents = state.MiniSitesReducers.searchResultListEvents;
    const dataSelectContent = state.MiniSitesReducers.dataSelectContent;
    const backoffficeUrl = state.MiniSitesReducers.backoffficeUrl;
    const reload = state.MiniSitesReducers.reload;
    return {
        searchResultListEvents,
        dataSelectContent,
        backoffficeUrl,
        reload
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchMiniSiteGetListEvents: (dataRequest) => dispatch(MiniSitesActions.fetchMiniSiteGetListEvents(dataRequest)),
        fetchMiniSiteSetAttributesSelectListEvents: (dataSelectContent) => dispatch(MiniSitesActions.fetchMiniSiteSetAttributesSelectListEvents(dataSelectContent)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(selectContentStyle)(SelectContent));